<template>
  <div class="w-3/12 m-auto mt-10">
    <vx-card title="Credenciales CdC" subtitle="Se actualizarán los datos en la AWS Parameter Store">
      <vs-input
          class="w-full"
          label="Usuario"
          v-model="credentials.username"></vs-input>
      <div>
        <vx-input-group class="w-full mt-3">
          <vs-input
              label="Contraseña"
              :type="passInputType" v-model="credentials.password"></vs-input>
          <template slot="append">
            <div class="append-text btn-addon mt-6">
              <vs-button color="dark" @click="showPassword = !showPassword" icon-pack="feather"
                         :icon="passInputIcon"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </div>

      <vs-button class="mt-4 w-full" @click="updateCredentialHandler">
        Guardar credenciales
      </vs-button>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "CdcConnection",
  data: () => ({
    credentials: {
      username: '',
      password: ''
    },
    showPassword: false
  }),
  computed: {
    passInputIcon() {
      return this.showPassword ? 'icon-eye' : 'icon-eye-off';
    },
    passInputType() {
      return this.showPassword ? 'text' : 'password';
    }
  },
  async mounted() {
    await axios.get(`/api/risk-model/configuration/cdc-connection`)
        .then(({data}) => {
          this.credentials = data;
        })
  },
  methods: {
    async updateCredentialHandler() {
      this.$vs.loading();
      try {
        await axios.put('/api/risk-model/configuration/cdc-connection', this.credentials)
        this.$vs.notify({
          title: 'Éxito',
          text: 'Credenciales actualizadas',
          color: 'success',
          position: 'top-right'
        });

      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>